import {STATUS_MODEL} from '../../../../enums/statusEnum';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

export const APPROVAL_TRACKER_MODEL = {
    approvalFlowId: null,
    levels: [
        {
            approvalCondition: "",
            approvers: [
                {
                    reason: "",
                    status: "",
                    userEmail: "",
                    userId: null,
                    userName: "",
                    statusId: null,
                }
            ],
            levelCompleted: true,
            levelId: null,
            levelInProgress: true,
            levelNumber: 0,
            levelStatus: "",
            levelStatusId: 0
        }
    ],
    moduleId: null,
    overallStatus: {
        id: null,
        name: ""
    },

    toRegister: function () {
        return {
            approvalFlowId: this.approvalFlowId,
            moduleId: this.moduleId,
            overallStatus: {
                id: this.overallStatus?.id ?? null,
                name: this.overallStatus?.name ?? ""
            },
            levels: this.levels.map((level) => ({
                approvalCondition: level.approvalCondition || "",
                approvers: level.approvers.map((a) => ({
                    reason: a.reason || "",
                    status: a.status || "",
                    userEmail: a.userEmail || "",
                    userId: a.userId || null,
                    userName: a.userName || "",
                    statusId: a.statusId || null,
                })),
                levelCompleted: level.levelCompleted ?? true,
                levelId: level.levelId || null,
                levelInProgress: level.levelInProgress ?? true,
                levelNumber: level.levelNumber ?? 0,
                levelStatus: level.levelStatus || "",
                levelStatusId: level.levelStatusId ?? 0,
            })),
        };
    },

    set: function (data) {
        return {
            ...this,
            approvalFlowId: data.approvalFlowId || null,
            moduleId: data.moduleId || null,
            overallStatus: {
                id: data.overallStatus?.id ?? null,
                name: data.overallStatus?.name ?? ""
            },
            levels: Array.isArray(data.levels)
                ? data.levels.map((level) => ({
                    approvalCondition: level.approvalCondition || "",
                    approvers: Array.isArray(level.approvers)
                        ? level.approvers.map((a) => ({
                            reason: a.reason || "",
                            status: a.status || "",
                            userEmail: a.userEmail || "",
                            userId: a.userId || null,
                            userName: a.userName || "",
                            statusId: a.statusId || null,
                        }))
                        : [],
                    levelCompleted: level.levelCompleted ?? true,
                    levelId: level.levelId || null,
                    levelInProgress: level.levelInProgress ?? true,
                    levelNumber: level.levelNumber ?? 0,
                    levelStatus: level.levelStatus || "",
                    levelStatusId: level.levelStatusId ?? 0,
                }))
                : [],
        };
    }
};

export const  APPROVAL_CONDITIONAL_MODEL = {
    ALL_MUST_APPROVE : "ALL_MUST_APPROVE",
    ONE_IS_ENOUGH : "ONE_IS_ENOUGH",
}

export const APPROVAL_TRACKER_DECISION_MODEL = {
    approvalFlowId: null,
    approvalLevelId: null,
    approvalStatusId: '',
    module: '',
    reason: '',
    subjectId: null,

    toRegister: function () {
        return {
            approvalFlowId: this.approvalFlowId,
            approvalLevelId: this.approvalLevelId,
            approvalStatusId: this.approvalStatusId,
            module: this.module,
            reason: this.reason,
            subjectId: this.subjectId,

        };
    },

    isValid: function () {
        return this.reason !== ""
    }
};

export const getToastMessageByStatus = (status) => {
    switch (status) {
        case STATUS_MODEL.APPROVED:
            return 'has_been_approved_successfully';
        case STATUS_MODEL.DENIED:
            return 'has_been_denied_successfully';
        case STATUS_MODEL.CHANGES_REQUESTED:
            return 'has_been_changes_successfully';
        default:
            return "has_been_created_successfully";
    }
};

export const getInfoParagraphByStatus = (status) => {
    switch (status) {
        case STATUS_MODEL.APPROVED:
            return 'you_can_leave_a_optional_comment';
        case STATUS_MODEL.DENIED:
            return 'please_provide_a_reason';
        case STATUS_MODEL.CHANGES_REQUESTED:
            return 'please_described_changes';
        default:
            return 'leave_a_comment';
    }
};


